"use client";

import React from "react";
import { NodeViewWrapper } from "@tiptap/react";
import Video from "@/components/Video";

interface VideoNodeFrontendProps {
  node: any;
}

export function VideoNodeFrontend({ node }: VideoNodeFrontendProps) {
  const { url, title, description } = node.attrs;

  // Build video object matching Video component's expected structure
  const videoData = {
    url: url || "",
    title: title || "",
    description: description || "",
    _isTiptapVideo: true, // Internal flag to hide data-tina-field
  };

  return (
    <NodeViewWrapper className="tiptap-video-wrapper">
      <Video
        video={videoData}
        variant="card"
        size="md"
        playInDialog={true}
        animateOnHover={false}
      />
    </NodeViewWrapper>
  );
}
